// Convert string to title case, MANCO -> Manco

import { ComponentType, SVGAttributes } from 'react';

import Combo from '@/assets/icons/Combo';
import Objects from '@/assets/icons/Objects';
import Omloop from '@/assets/icons/Omloop';
import Train from '@/assets/icons/Train';
import TrainNumber from '@/assets/icons/TrainNumber';
import TrainUnit from '@/assets/icons/TrainUnit';
import { AdvancedSearchData, SearchModality, SearchType } from '@/components/search/types';

export const SEARCH_ADD_TOGGLE_STORAGE_KEY = 'addSearchResults';

export const capitalizeFirstLetter = (value: string) => `${value[0].toUpperCase()}${value.slice(1).toLowerCase()}`;

// get the icon component for the searched history
export const getSearchedHistoryIcon = (searchType: string): ComponentType<SVGAttributes<SVGSVGElement>> => {
  const iconsMap: Record<string, ComponentType<SVGAttributes<SVGSVGElement>>> = {
    train: TrainNumber,
    trainAndRollingStock: Combo,
    rollingStock: TrainUnit,
    rollingStockType: Train,
    omloop: Omloop,
    json: Objects,
  };
  return iconsMap[searchType] ?? TrainNumber;
};

// get the corresponding name for the search type
export const getClientNameFromSearchType = (searchType?: string) => {
  const clientNames = {
    trainAndRollingStock: 'Trein / Eenheid',
    train: 'Trein',
    rollingStock: 'Eenheid',
    rollingStockType: 'Materieeltype',
    omloop: 'Omloop',
    json: 'JSON',
    bijzonderheidscode: 'Bijzonderheidscode',
  };
  return clientNames?.[searchType as keyof typeof clientNames] ?? ' ';
};

// get the corresponding name for the search modality
export const getClientNameFromSearchModality = (searchModality?: SearchModality, searchType?: SearchType) => {
  const clientNames = {
    single: {
      trainAndRollingStock: 'treinnummer / materieelnummer',
      train: 'treinnummer',
      rollingStock: 'materieelnummer',
    },
    multiple: {
      trainAndRollingStock: 'treinnummers / materieelnummers',
      train: 'treinnummers',
      rollingStock: 'materieelnummers',
    },
    range: {
      trainAndRollingStock: 'treinreeks / materieelreeks',
      train: 'treinreeks',
      rollingStock: 'materieelreeks',
    },
  } as { [modality: string]: { [searchType: string]: string } };
  return clientNames?.[searchModality as keyof typeof clientNames]?.[searchType as never] ?? ' ';
};

// Match with support for '*' wildcard at the end of search term
export const wildcardMatch = (pattern: string, value: string) => {
  const indexOfAsterisk = pattern.indexOf('*');
  if (indexOfAsterisk < 0) {
    return pattern === value;
  }
  const startOfString = pattern.substring(0, indexOfAsterisk);
  return value.startsWith(startOfString);
};

export const searchCriteriaForIds: (ids: string[]) => AdvancedSearchData = (ids) => {
  return {
    criteria: [
      {
        veld: 'werklijn.id',
        waarden: ids,
      },
    ],
  };
};

export const searchCriteriaForEenheden: (eenheden: string[]) => AdvancedSearchData = (eenheden) => {
  return {
    criteria: [
      {
        veld: 'eenheid.nummer',
        waarden: eenheden,
      },
    ],
  };
};

export const searchCriteriaForTreinnummers: (treinnummers: string[], treindatums: string[]) => AdvancedSearchData = (
  treinnummers: string[],
  treindatums: string[],
) => {
  return {
    criteria: [
      { veld: 'beweging.treinnummer', waarden: treinnummers },
      { veld: 'verkeersdatum', waarden: treindatums },
    ],
  };
};
